import type { InspectionTemplate } from 'inspection-types';

export function countSectionsAndQuestions(template: InspectionTemplate): {
  sections: number;
  questions: number;
} {
  const sections = template.sections.length;
  const questions = template.sections.reduce(
    (total, section) => total + section.items.length,
    0
  );
  return { sections, questions };
}

export function formatQuestionOrdinal(
  sectionIndex: number,
  itemIndex: number
): string {
  return `${sectionIndex + 1}.${itemIndex + 1}`;
}

/** Section title prefix for accordion and sidebar (e.g. "1. Interior"). */
export function formatSectionTitle(sectionIndex: number, name: string): string {
  return `${sectionIndex + 1}. ${name}`;
}
